import { SVGProps } from 'react';

const InitialAlignment = ({ props }: { props?: SVGProps<SVGSVGElement> }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="534" height="340" viewBox="0 0 534 340" fill="none" {...props}>
    <g clipPath="url(#bto-clip)">
      <g filter="url(#bto-blur)">
        <ellipse
          cx="328.854"
          cy="237.945"
          fill="#142557"
          rx="328.854"
          ry="237.945"
          transform="scale(-1 1) rotate(-1.064 9872.706 34178.611)"
        />
      </g>
      <circle cx="267" cy="170" r="41" fill="url(#bto-c)" />
      <circle cx="267" cy="91" r="13" fill="url(#bto-d)" />
      <circle cx="346" cy="170" r="13" fill="url(#bto-e)" />
      <circle cx="267" cy="249" r="13" fill="url(#bto-f)" />
      <circle cx="188" cy="170" r="13" fill="url(#bto-g)" />
      <circle cx="214.5" cy="117.5" r="12.5" fill="url(#bto-h)" />
      <circle cx="214.5" cy="222.5" r="12.5" fill="url(#bto-i)" />
      <circle cx="319.5" cy="117.5" r="12.5" fill="url(#bto-j)" />
      <circle cx="319.5" cy="222.5" r="12.5" fill="url(#bto-k)" />
      <circle cx="267" cy="170" r="22" fill="url(#bto-l)" />
      <ellipse cx="267" cy="90.5" fill="url(#bto-m)" rx="6" ry="6.5" />
      <ellipse cx="346.5" cy="170" fill="url(#bto-n)" rx="6.5" ry="6" />
      <ellipse cx="267" cy="249.5" fill="url(#bto-o)" rx="6" ry="6.5" />
      <ellipse cx="187.5" cy="170" fill="url(#bto-p)" rx="6.5" ry="6" />
      <circle cx="214.5" cy="117.5" r="6.5" fill="url(#bto-q)" />
      <circle cx="214.5" cy="222.5" r="6.5" fill="url(#bto-r)" />
      <circle cx="319.5" cy="117.5" r="6.5" fill="url(#bto-s)" />
      <circle cx="319.5" cy="222.5" r="6.5" fill="url(#bto-t)" />
    </g>
    <defs>
      <linearGradient id="bto-c" x1="267" x2="267" y1="129" y2="211" gradientUnits="userSpaceOnUse">
        <stop stopColor="#193B8F" />
        <stop offset="1" stopColor="#142557" />
      </linearGradient>
      <linearGradient id="bto-d" x1="267" x2="267" y1="78" y2="104" gradientUnits="userSpaceOnUse">
        <stop stopColor="#193B8F" />
        <stop offset="1" stopColor="#142557" />
      </linearGradient>
      <linearGradient id="bto-e" x1="346" x2="346" y1="157" y2="183" gradientUnits="userSpaceOnUse">
        <stop stopColor="#193B8F" />
        <stop offset="1" stopColor="#142557" />
      </linearGradient>
      <linearGradient id="bto-f" x1="267" x2="267" y1="236" y2="262" gradientUnits="userSpaceOnUse">
        <stop stopColor="#193B8F" />
        <stop offset="1" stopColor="#142557" />
      </linearGradient>
      <linearGradient id="bto-g" x1="188" x2="188" y1="157" y2="183" gradientUnits="userSpaceOnUse">
        <stop stopColor="#193B8F" />
        <stop offset="1" stopColor="#142557" />
      </linearGradient>
      <linearGradient id="bto-h" x1="214.5" x2="214.5" y1="105" y2="130" gradientUnits="userSpaceOnUse">
        <stop stopColor="#193B8F" />
        <stop offset="1" stopColor="#142557" />
      </linearGradient>
      <linearGradient id="bto-i" x1="214.5" x2="214.5" y1="210" y2="235" gradientUnits="userSpaceOnUse">
        <stop stopColor="#193B8F" />
        <stop offset="1" stopColor="#142557" />
      </linearGradient>
      <linearGradient id="bto-j" x1="319.5" x2="319.5" y1="105" y2="130" gradientUnits="userSpaceOnUse">
        <stop stopColor="#193B8F" />
        <stop offset="1" stopColor="#142557" />
      </linearGradient>
      <linearGradient id="bto-k" x1="319.5" x2="319.5" y1="210" y2="235" gradientUnits="userSpaceOnUse">
        <stop stopColor="#193B8F" />
        <stop offset="1" stopColor="#142557" />
      </linearGradient>
      <linearGradient id="bto-l" x1="267" x2="267" y1="148" y2="192" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4190FF" />
        <stop offset="1" stopColor="#8EC9FF" />
      </linearGradient>
      <linearGradient id="bto-m" x1="267" x2="267" y1="84" y2="97" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4190FF" />
        <stop offset="1" stopColor="#8EC9FF" />
      </linearGradient>
      <linearGradient id="bto-n" x1="346.5" x2="346.5" y1="164" y2="176" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4190FF" />
        <stop offset="1" stopColor="#8EC9FF" />
      </linearGradient>
      <linearGradient id="bto-o" x1="267" x2="267" y1="243" y2="256" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4190FF" />
        <stop offset="1" stopColor="#8EC9FF" />
      </linearGradient>
      <linearGradient id="bto-p" x1="187.5" x2="187.5" y1="164" y2="176" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4190FF" />
        <stop offset="1" stopColor="#8EC9FF" />
      </linearGradient>
      <linearGradient id="bto-q" x1="214.5" x2="214.5" y1="111" y2="124" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4190FF" />
        <stop offset="1" stopColor="#8EC9FF" />
      </linearGradient>
      <linearGradient id="bto-r" x1="214.5" x2="214.5" y1="216" y2="229" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4190FF" />
        <stop offset="1" stopColor="#8EC9FF" />
      </linearGradient>
      <linearGradient id="bto-s" x1="319.5" x2="319.5" y1="111" y2="124" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4190FF" />
        <stop offset="1" stopColor="#8EC9FF" />
      </linearGradient>
      <linearGradient id="bto-t" x1="319.5" x2="319.5" y1="216" y2="229" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4190FF" />
        <stop offset="1" stopColor="#8EC9FF" />
      </linearGradient>
      <clipPath id="bto-clip">
        <rect width="534" height="340" fill="#fff" rx="12.622" />
      </clipPath>
      <filter
        id="bto-blur"
        width="1257.66"
        height="1075.97"
        x="-329.103"
        y="-116.974"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_186_1305" stdDeviation="150" />
      </filter>
    </defs>
  </svg>
);

export default InitialAlignment;
